import axios from 'axios';
import {getCookie, removeCookieWithLocalStorage} from "./browserStorageHelper"
import { logoutLocal } from '../store'
// import { useDispatch } from 'react-redux';
import { store } from '../store';

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL, 
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true, // cookie hamt ilgeeh
});

// Request Interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    const {accessToken, refreshToken}=getCookie();
    // const token = localStorage.getItem('authUser') ? JSON.parse(localStorage.getItem('authUser')).token : null;
    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`; 
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response Interceptor
axiosInstance.interceptors.response.use(
  (response) => {
    // console.log(response.data);

    const data ={
      data: response.data
    };
    if(response?.pagination) data['pagination']=response?.pagination;
    return data;
  },
  (error) => {
    // const dispatch = useDispatch();
    // Handle errors globally
    let errorMessage = 'Алдаа гарлаа';
    if (error.response) {
      // Server responded with a status other than 200 range
      switch (error.response.status) {
        case 401:
          errorMessage = 'Invalid credentials';
          // dispatch(logoutLocal());
          store.dispatch(logoutLocal());
          break;
        case 403:
          errorMessage = error.response.data.msg || error.response.data.error || 'Танд энэ үйлдлийг хийх эрх байхгүй байна';
          break;
        case 404:
          errorMessage = error.response.data.msg || error.response.data.error || 'Мэдээлэл олдсонгүй';
          break;
        case 500:
          errorMessage = error.response.data.msg || error.response.data.error || 'Сервел талд алдаа гарлаа';       
          break;
        default:
          errorMessage = error.response.data.msg || error.response.data.error || errorMessage;
      }
    }
    return Promise.reject(errorMessage);
  }
);

export default axiosInstance;